module.exports = __webpack_public_path__ + "img/10.a7b82c6f.jpg";